var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBoxTickSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "box-tick-svgrepo-com 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector",
    filter: "url(#filter0_d_1465_12234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60.3125 25.7915L47.2084 18.7291C45.8334 17.9791 44.1667 17.9791 42.7709 18.7291L29.6667 25.7915C28.7084 26.3124 28.125 27.3333 28.125 28.4583C28.125 29.5833 28.7084 30.604 29.6667 31.1249L42.7709 38.1875C43.4584 38.5625 44.2292 38.75 44.9792 38.75C45.7292 38.75 46.5 38.5625 47.1875 38.1875L60.2917 31.1249C61.25 30.604 61.8334 29.5833 61.8334 28.4583C61.875 27.3333 61.2709 26.3124 60.3125 25.7915Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter1_d_1465_12234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6302 40.6456L28.4427 34.5414C27.5052 34.0623 26.4219 34.1248 25.526 34.6664C24.6302 35.2081 24.1094 36.1665 24.1094 37.2081V48.729C24.1094 50.729 25.2135 52.5206 27.0052 53.4165L39.1927 59.4998C39.6094 59.7081 40.0677 59.8123 40.5261 59.8123C41.0677 59.8123 41.6094 59.6664 42.0885 59.3539C42.9844 58.8123 43.5052 57.854 43.5052 56.8123V45.2915C43.526 43.3331 42.4219 41.5415 40.6302 40.6456Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Vector_3",
    filter: "url(#filter2_d_1465_12234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M65.901 37.2296V46.7919C65.8802 46.7711 65.8594 46.7294 65.8385 46.7086C65.8385 46.6877 65.8179 46.6669 65.7971 46.6461C65.7137 46.5211 65.6094 46.3961 65.5052 46.2919C65.4844 46.2711 65.4635 46.2296 65.4427 46.2088C63.7552 44.3338 61.276 43.1669 58.5469 43.1669C55.9219 43.1669 53.526 44.2502 51.8177 46.0002C50.1719 47.6877 49.1719 50.0002 49.1719 52.5419C49.1719 54.2919 49.6719 55.9586 50.526 57.3752C50.8802 57.9794 51.3179 58.5211 51.7971 59.0211L50.8179 59.5211C50.4012 59.7294 49.9427 59.8336 49.4844 59.8336C48.9427 59.8336 48.4012 59.688 47.9012 59.3755C47.0262 58.8338 46.4844 57.8752 46.4844 56.8336V45.3336C46.4844 43.3336 47.5887 41.5419 49.3804 40.6461L61.5679 34.5628C62.5054 34.0836 63.5887 34.1253 64.4846 34.6878C65.3596 35.2294 65.901 36.188 65.901 37.2296Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M65.7891 46.6459C64.0807 44.5417 61.4766 43.2084 58.5391 43.2084C56.3307 43.2084 54.2891 43.9792 52.6849 45.2709C50.5182 46.9792 49.1641 49.625 49.1641 52.5834C49.1641 54.3334 49.6641 56 50.5182 57.4167C51.0807 58.3542 51.7891 59.1667 52.6224 59.8334H52.6432C54.2474 61.1667 56.3099 61.9584 58.5391 61.9584C60.9141 61.9584 63.0599 61.0834 64.7057 59.625C65.4349 59 66.0599 58.25 66.5599 57.4167C67.4141 56 67.9141 54.3334 67.9141 52.5834C67.9141 50.3334 67.1224 48.25 65.7891 46.6459ZM63.2474 51.4167L58.2474 56.0417C57.9557 56.3125 57.5599 56.4584 57.1849 56.4584C56.7891 56.4584 56.3932 56.3125 56.0807 56L53.7682 53.6875C53.1641 53.0834 53.1641 52.0834 53.7682 51.4792C54.3724 50.875 55.3724 50.875 55.9766 51.4792L57.2266 52.7292L61.1224 49.125C61.7474 48.5417 62.7474 48.5834 63.3307 49.2084C63.9349 49.8542 63.8932 50.8334 63.2474 51.4167Z",
    fill: "#0DBA1E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1465_12234",
    x: 4.125,
    y: 0.166626,
    width: 81.7109,
    height: 68.5834,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_12234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_12234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1465_12234",
    x: 0.109375,
    y: 16.2179,
    width: 67.3984,
    height: 73.5944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_12234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_12234",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1465_12234",
    x: 22.4844,
    y: 16.2322,
    width: 67.4141,
    height: 73.6014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1465_12234"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1465_12234",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxTickSvgrepoCom1);
export default __webpack_public_path__ + "static/media/box-tick-svgrepo-com 1.0bec4782d1c34cd37c3012b27613e619.svg";
export { ForwardRef as ReactComponent };